import { type ComponentType, useMemo } from 'react'

import type { DrugTimelineItem } from '~/types'

import { BaseRxCard } from '../BaseRxCard'
import { convertToRxCardItem } from '../prescriptions/rxCardItem'

export interface RxOrderedDrugCardProps {
  actionNeeded?: boolean
  clientId: string
  icon?: ComponentType<{ className?: string }>
  id?: string
  index: number
  isInvoice?: boolean
  item: DrugTimelineItem
  onClick?: () => void
  patientId: string
  titlePinColor?: string | null
}

/**
 * Card component for displaying ordered drugs in the timeline.
 * Converts DrugTimelineItem to RxCardItem and delegates to BaseRxCard.
 */
export const RxOrderedDrugCard = ({
  clientId,
  item,
  patientId,
  ...props
}: RxOrderedDrugCardProps) => {
  const rxItem = useMemo(
    () => convertToRxCardItem(item, { clientId, patientId }),
    [item, clientId, patientId],
  )

  if (!rxItem) {
    return null
  }

  return <BaseRxCard item={rxItem} {...props} />
}
